import React from 'react';

const IconNotifications = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23">
    <g id="Group_8671" data-name="Group 8671" transform="translate(-30 -878)">
      <g id="Group_8252" data-name="Group 8252" transform="translate(30 879.836)">
        <path id="bell" d="M9.056,20.782a2.6,2.6,0,0,0,2.634-2.6h-5.2A2.587,2.587,0,0,0,9.056,20.782Zm8.78-6.076c-.781-.842-2.253-2.111-2.253-6.263a6.4,6.4,0,0,0-5.192-6.3V1.3a1.3,1.3,0,1,0-2.6,0v.848a6.4,6.4,0,0,0-5.19,6.3C2.6,12.6,1.132,13.862.35,14.706a1.284,1.284,0,0,0-.35.881,1.3,1.3,0,0,0,1.3,1.3H16.883a1.293,1.293,0,0,0,.953-2.18Z" transform="translate(0 0)" fill="#1d3853" />
        <g id="Ellipse_547" data-name="Ellipse 547" transform="translate(11.472 4.62)" fill="#d60101" stroke="#fff" stroke-width="0.7" opacity="1">
          <ellipse cx="4.08" cy="4.08" rx="4.08" ry="4.08" stroke="none" />
          <ellipse cx="4.08" cy="4.08" rx="3.73" ry="3.73" fill="none" />
        </g>
      </g>
    </g>
  </svg>
);

export default IconNotifications;
